import React from 'react';

import RippleLoader from "../RippleLoader/RippleLoader";

export interface AppLoaderProps {
}

const AppLoader: React.FunctionComponent<AppLoaderProps> = (props) => {


    return (
        <div className="loader opacity active">
            <RippleLoader text='Caricamento' />
        </div>
    )
}

export default AppLoader;